var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6h48v48H6z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#394149",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.41 34.034l3.672.967a1.5 1.5 0 0 0 1.692-2.182l-.899-1.609C46.872 29.262 48 26.78 48 24.143c0-6.059-5.905-10.904-13.125-10.904S21.75 18.084 21.75 24.143c0 6.058 5.905 10.904 13.125 10.904a15.37 15.37 0 0 0 5.535-1.013z",
    fill: "#738CE6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.258 44.7l-4.004 1.028a1.5 1.5 0 0 1-1.674-2.198l.987-1.724c-2.119-2.011-3.317-4.578-3.317-7.306 0-6.255 6.244-11.25 13.875-11.25C32.755 23.25 39 28.245 39 34.5s-6.244 11.25-13.875 11.25c-2.054 0-4.046-.362-5.867-1.05z",
    fill: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubbles);
export default __webpack_public_path__ + "static/media/speech-bubbles.477a8d8c422a8c5e258d18f6c0079582.svg";
export { ForwardRef as ReactComponent };